import { useQuery } from "@tanstack/react-query";
import { Check, RefreshCw } from "lucide-react";

import { orpc } from "@/client";
import { Button } from "@/components/ui/button";

import { ConversationContextAction } from "./action";

export function ConversationContextActions({ personId }: { personId: number }) {
	const { data, isPending, isError, refetch } = useQuery(
		orpc.cockpit.personActions.queryOptions({ input: { person_id: personId } }),
	);

	return (
		<section
			className="shrink-0 border-b border-primary/15 bg-primary-soft px-6 py-5"
			aria-label="Pendências da conversa"
		>
			<header className="flex items-center justify-between gap-3">
				<h3 className="text-xs font-semibold text-primary">Pendências</h3>
				{!!data?.length && (
					<span className="grid size-5 place-items-center rounded-full bg-primary font-mono text-xs text-background">
						{data.length}
					</span>
				)}
			</header>
			{isPending && (
				<div
					className="mt-4 h-24 animate-pulse rounded-md bg-background"
					aria-label="Carregando pendências"
				/>
			)}
			{isError && (
				<div role="alert" className="mt-3 space-y-2 text-xs text-muted-foreground">
					<p>Não foi possível carregar as pendências.</p>
					<Button variant="ghost" size="sm" onClick={() => refetch()}>
						<RefreshCw /> Tentar de novo
					</Button>
				</div>
			)}
			{!isPending && !isError && data.length === 0 && (
				<p className="mt-4 flex items-center gap-2 text-sm text-muted-foreground">
					<Check className="size-4 text-primary" /> Nenhuma pendência aberta.
				</p>
			)}
			<div className="divide-y divide-primary/15">
				{data?.map((action) => (
					<ConversationContextAction key={action.id} action={action} />
				))}
			</div>
		</section>
	);
}
